import React, { useState } from 'react';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import { FileItemProps } from '../FileItem/FileItem.component';
import { Menu, MenuItem } from '@mui/material';

export type FolderBreadCrumbItem = {
  isDisabled: boolean;
  file: FileItemProps;
  path: string;
  key: string;
  onPathClicked: (path: string) => void;
};


const FolderBreadCrumbItem = ({
  isDisabled,
  file, 
  path,
  key,
  onPathClicked
}: FolderBreadCrumbItem) => {
  const { name, files = [] } = file;
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const handleClick = (event: React.MouseEvent<HTMLDivElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleMenuItemClick = (fileName: string) => {
    onPathClicked(`${path}/${fileName}`);
    setAnchorEl(null);
  };

  return (
    <div 
      className={`folder-bread-crumbs__item ${isDisabled ? 'disabled' : ''}`}
      key={key}
    >
      <span 
        data-testid={`folder-bread-crumbs-item-${name}`}
        onClick={() => onPathClicked(path)}
      >
        {name} 
      </span>
      { !isDisabled && (
        <div 
          className={`folder-bread-crumbs__item__icon ${open ? 'hovered': ''}`}
          onClick={handleClick}
          >
          <KeyboardArrowRightIcon 
            style={{ fontSize: '16px' }}
          />
        </div>
      )}
      <Menu
        id={`basic-menu-${file.id}`}
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        classes={{ paper: 'breadcrumb-menu', list: 'breadcrumb-menu__list' }}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}
        MenuListProps={{
          'aria-labelledby': 'basic-button',
        }}
      >
        { 
          files
          .filter(({ type }) => type === 'folder')
          .map(({ name, id }, index) => (
            <MenuItem onClick={() => handleMenuItemClick(name)} key={`${id}`}>{ name }</MenuItem>
          ))
        }
      </Menu>
    </div>
  );
};

export default FolderBreadCrumbItem;
